<div class="dialog">
    <button class="close-button" (click)="onClose()">
        <span class="material-symbols-outlined">close</span>
    </button>
    @if (tool) {
        <div class="dialog-content">
            <div class ="header">
                @if (tool.status != 'Deprecated') {
                    <h2>
                        {{tool.name}}
                        @if (tool.isRecommended){
                            <span class="material-symbols-outlined" ngbTooltip="Preferred" placement="right">
                                thumbs_up_double
                            </span>
                        }
                    </h2>
                }
                @else {
                    <h2 class='deprecated-tool'>
                        {{tool.name}}
                        <span class="material-symbols-outlined" ngbTooltip="This tool is deprecated. Check alternative tools for similar solutions." placement="right">
                            warning_amber
                        </span>
                    </h2>
                }
                @if (displayedFacets.length > 0) {
                    <facet-chips [displayedFacets]="displayedFacets"></facet-chips>
                }
            </div>
            <div class="row g-1">
                <div class="col-md-8">
                    <div class="description-container">
                        <p>
                            <span [innerHTML]="tool.description | safeHtml"></span>
                            @if (tool.specialCondition) {
                                <br>
                                <strong>Special Condition:</strong>
                                <br>
                                <span [innerHTML]="tool.specialCondition | safeHtml"></span>
                            }
                        </p>
                    </div>
                    <image-carousel 
                        [previewImageUrls]="imageUrls" 
                        [galleryImageUrls]="galleryImageUrls">
                    </image-carousel>
                </div>
                <div class="col-md-4">
                    <div class="details-container">
                        <div ngbAccordion [closeOthers]="true">
                            <div ngbAccordionItem [collapsed]="false">
                                <h2 ngbAccordionHeader>
                                    <button ngbAccordionButton>Documentations</button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <ng-template>
                                            @if (tool.documentationLinks && tool.documentationLinks.length > 0) {
                                                @for (document of tool.documentationLinks; track document) {
                                                    <li>
                                                        <a [href]="document.url" target="_blank" (click)="$event.stopPropagation()">
                                                            <span class="material-symbols-outlined">link</span>{{document.title}}
                                                        </a>
                                                    </li>
                                                }
                                            } 
                                            @else {
                                                <li>No documentation available.</li>
                                            }
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <hr class="accordion-divider" />
                            <div ngbAccordionItem [collapsed]="true">
                                <h2 ngbAccordionHeader>
                                    <button ngbAccordionButton>Alternative Tools</button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <ng-template>
                                            @if (tool.alternativeTools && tool.alternativeTools.length > 0) {
                                                @for (alternativeTool of tool.alternativeTools; track alternativeTool) {
                                                    <li>
                                                        <a [href]="baseUrl + 'tooling?Id=' + alternativeTool.id" target="_blank" (click)="$event.stopPropagation()">
                                                            @if (alternativeTool.relationshipType == 'Recommended'){
                                                                <span class="material-symbols-outlined recommended-tool">settings_suggest</span>
                                                            }
                                                            @else {
                                                                <span class="material-symbols-outlined">settings</span>
                                                            }
                                                            {{alternativeTool.name}}
                                                    </a>
                                                    </li>
                                                }
                                            } 
                                            @else {
                                                <li>No alternative tools available.</li>
                                            }
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <hr class="accordion-divider" />
                            <div ngbAccordionItem [collapsed]="true">
                                <h2 ngbAccordionHeader>
                                    <button ngbAccordionButton>
                                        <span>Contacts</span>
                                    </button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    @if (tool.contacts && tool.contacts.length > 0) {
                                        <div ngbAccordionBody>
                                            <contacts-block [contacts]="tool.contacts ? tool.contacts : []"></contacts-block>
                                        </div>
                                    } @else {
                                        <div ngbAccordionBody>
                                            <li>No contacts available.</li>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <a [href]="tool.url" class="button access-button" target="blank" (click)="tool.url == ''? $event.preventDefault(): null">
                        @if(tool.launchType) {{{ tool.launchType }}}
                        @else { access tool }
                    </a>
                </div>
            </div>
        </div>
    }
    @else {
            <div class="col-md-12" id="noRecord">
                <p align="center">No record found for this ID.</p>
            </div>
    }
</div>